module.exports = __webpack_public_path__ + "img/planner-filter-sentosa.6a070eaa.svg";